import { FC } from "react"
import './index.css'

type QuantityButtonProps = {
  changeValuePositive: () => void;
  changeValueNegative: () => void;
  value: number
  size?: number
}

type buttonProps = {
  action: () => void
}

const PlusIcon: FC<buttonProps> = ({ action }) => {
  return (
    <svg
      style={{ cursor: "pointer" }}
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => action()}
    >
      <path d="M10.8174 4.61035V6.47949H0.0966797V4.61035H10.8174ZM6.45605 0.0449219V11.4316H4.46875V0.0449219H6.45605Z" fill="#37393D" />
    </svg>

  )
}

const MinusIcon: FC<buttonProps> = ({ action }) => {
  return (
    <svg
      style={{ cursor: "pointer" }}
      width="13"
      height="3"
      viewBox="0 0 13 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => action()}
    >
      <path d="M13 1.5C13 1.9375 12.6562 2.25 12.25 2.25H0.75C0.3125 2.25 0 1.9375 0 1.5C0 1.09375 0.3125 0.75 0.75 0.75H12.25C12.6562 0.75 13 1.09375 13 1.5Z" fill="#37393D" />
    </svg>


  )
}
export const TrashIcon: FC<buttonProps> = ({ action }) => {
  return (
    <svg
      style={{ cursor: "pointer" }}
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => action()}
    >
      <path d="M5.53125 2C5.4375 2 5.375 2.0625 5.3125 2.125L4.71875 3H9.25L8.65625 2.125C8.625 2.0625 8.53125 2 8.4375 2H5.53125ZM11.0625 3H11.4688H13H13.25C13.6562 3 14 3.34375 14 3.75C14 4.1875 13.6562 4.5 13.25 4.5H12.875L12.125 14.6562C12.0312 15.7188 11.1875 16.5 10.125 16.5H3.84375C2.78125 16.5 1.9375 15.7188 1.84375 14.6562L1.09375 4.5H0.75C0.3125 4.5 0 4.1875 0 3.75C0 3.34375 0.3125 3 0.75 3H1H2.5H2.90625L4.0625 1.28125C4.375 0.8125 4.9375 0.5 5.53125 0.5H8.4375C9.03125 0.5 9.59375 0.8125 9.90625 1.28125L11.0625 3ZM11.375 4.5H2.59375L3.34375 14.5625C3.375 14.8125 3.59375 15 3.84375 15H10.125C10.375 15 10.5938 14.8125 10.625 14.5625L11.375 4.5Z" fill="#37393D" />
    </svg>

  )
}

const ProdutoButtonQuantity: FC<QuantityButtonProps> = ({ changeValuePositive, changeValueNegative, value }) => {
  return (
    <div className="optionsBody">

      {value > 1 ? <MinusIcon action={() => changeValueNegative()} /> : <TrashIcon action={() => changeValueNegative()} />

      }

      <p className="value">{value}</p>


      <PlusIcon action={() => changeValuePositive()} />

    </div>
  )
}

const ProdutoButtonQuantityNew: FC<QuantityButtonProps> = ({ changeValuePositive, changeValueNegative, value }) => {
  return (
    <div className="optionsBody">

      <MinusIcon action={() => changeValueNegative()} />

      <p className="value">{value}</p>


      <PlusIcon action={() => changeValuePositive()} />

    </div>
  )
}

export { ProdutoButtonQuantity, ProdutoButtonQuantityNew }